import React, {useState, useEffect, useRef} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Menu from "../../../components/layout/menu/index";
import FilterInput from "../../../components/filters/filterInput";
import PdfCard from "../../../components/card/pdfCard";
import NewsCard from "../../../components/card/newsCard";
import { getManuals, downloadManual, getManual} from "../../../client/manuals/index"
import DateFilterButton from "../../../components/filters/dateFilterButton";
import { getNews, deleteNews} from "../../../client/news/index"
import ResetFilters from "../../../components/filters/resetFilters";
import ContentLoader from "react-content-loader";
import { useModuleAdherence } from "../../../hooks/userAdherence/index";
import ModalAlertWarning from "../../../components/shared/modals/modalAlertWarning";
import { axiosInstance } from '../../../client';

const PdfCardLoader = () => (
  <div className="flex flex-col items-center justify-center gap-3">
    <div className="relative overflow-hidden drop-shadow-manual rounded-lg h-[320px] w-[230px]">
      <ContentLoader 
        speed={2}
        width={230}
        height={320}
        viewBox="0 0 230 320"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="0" rx="8" ry="8" width="230" height="320" />
      </ContentLoader>
    </div>
  </div>
);

const NewsCardLoader = () => (
  <div className="w-[267px] h-[314px]">
    <ContentLoader 
      speed={2}
      width={267}
      height={314}
      viewBox="0 0 267 314"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="0" y="0" rx="12" ry="12" width="267" height="185" />
      <rect x="16" y="200" rx="4" ry="4" width="180" height="18" />
      <rect x="16" y="230" rx="3" ry="3" width="235" height="10" />
      <rect x="16" y="250" rx="3" ry="3" width="220" height="10" />
      <rect x="16" y="270" rx="6" ry="6" width="70" height="24" />
      <rect x="176" y="270" rx="6" ry="6" width="90" height="24" />
    </ContentLoader>
  </div>
);

export default function KnowUsProvider() {
  useModuleAdherence(12);

  const navigate = useNavigate();
  const location = useLocation(); 

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [currentPdfIndex, setCurrentPdfIndex] = useState(0);
  const [currentNewsIndex, setCurrentNewsIndex] = useState(0);
  const pdfCarouselRef = useRef(null);
  const newsCarouselRef = useRef(null);

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [maxVisibleCards, setMaxVisibleCards] = useState(3);
  const [maxVisibleNews, setMaxVisibleNews] = useState(3);

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [manuals, setManuals] = useState([]);

  const [viewModalUrl, setViewModalUrl] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewModalBlobUrl, setViewModalBlobUrl] = useState(null);
  const [viewModalError, setViewModalError] = useState(false);

  const [showModalSuccess, setShowModalSuccess] = useState(false);

  const [showModalAlertWarning, setShowModalAlertWarning] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  //noticias
  const [news, setNews] = useState([]);
  const [isNewsLoading, setIsNewsLoading] = useState(true);
  const [newsError, setNewsError] = useState(null);

const [dateFilters, setDateFilters] = useState({
  createDateFrom: "",
  createDateTo: ""
});

  useEffect(() => {
    if (location.state?.showSuccess && location.state?.message) {
      setModalMessage(location.state.message);
      setShowModalSuccess(true);
      
      navigate(location.pathname, { replace: true, state: {} });
      
      fetchNews();
    }
  }, [location.state, location.pathname, navigate]);

useEffect(() => {
  const calculateVisibleCards = () => {
    const screenWidth = window.innerWidth;
    
    const adjustedWidth = isMenuOpen 
      ? screenWidth - (screenWidth >= 1280 ? screenWidth * 0.207 : screenWidth >= 1024 ? screenWidth * 0.237 : 0)
      : screenWidth;
    
    // Para PDF cards
    if (adjustedWidth < 570) {
      setMaxVisibleCards(1);
    } else if (adjustedWidth < 800) {
      setMaxVisibleCards(2);
    } else if (adjustedWidth < 1100) {
      setMaxVisibleCards(3);
    } else {
      setMaxVisibleCards(4);
    }
    
    // Para News cards
      if (adjustedWidth < 642) {
        setMaxVisibleNews(1);
      } else if (adjustedWidth < 936) {
        setMaxVisibleNews(2);
      } else if (adjustedWidth < 1256) {
        setMaxVisibleNews(3);
      } else if (adjustedWidth < 1570) {
        setMaxVisibleNews(4);
      }  else if (adjustedWidth < 1590) {
        setMaxVisibleNews(5);
      } 
  };

  calculateVisibleCards();

  const handleResize = () => {
    calculateVisibleCards();
  };

  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, [isMenuOpen]); 

useEffect(() => {
  const calculateVisibleCards = () => {
    const screenWidth = window.innerWidth;
    
    const adjustedWidth = isMenuOpen 
      ? screenWidth - (screenWidth >= 1280 ? screenWidth * 0.207 : screenWidth >= 1024 ? screenWidth * 0.237 : 0)
      : screenWidth;
    
    // Para PDF cards
    if (adjustedWidth < 570) {
      setMaxVisibleCards(1);
    } else if (adjustedWidth < 800) {
      setMaxVisibleCards(2);
    } else if (adjustedWidth < 1100) {
      setMaxVisibleCards(3);
    } else {
      setMaxVisibleCards(4);
    }
    
    // Para News cards
    if (adjustedWidth < 642) {
      setMaxVisibleNews(1);
    } else if (adjustedWidth < 900) {
      setMaxVisibleNews(2);
    } else if (adjustedWidth < 1200) {
      setMaxVisibleNews(3);
    } else {
      setMaxVisibleNews(4);
    }
  };

  calculateVisibleCards();
}, [isMenuOpen]);

const fetchNews = async (searchTerm = "", dateFilters = {}) => {
    try {
      setIsNewsLoading(true);
      const response = await getNews(searchTerm, dateFilters.createDateFrom, dateFilters.createDateTo);
    if (response.data && response.data.news) {
      const visibleNews = response.data.news.filter(newsItem => newsItem.visible === true);
      setNews(visibleNews);
    }
    setIsNewsLoading(false);
    } catch (err) {
      setNewsError("Error al cargar las noticias");
      setIsNewsLoading(false);
      console.error("Error fetching news:", err);
    }
  };

const fetchManuals = async (searchTerm = "", dateFilters = {}) => {
    try {
      setIsLoading(true);
      const response = await getManuals("KnowUs", searchTerm, dateFilters.createDateFrom, dateFilters.createDateTo);
    if (response.data && response.data.manuals) {
      const visibleManuals = response.data.manuals.filter(manual => manual.visible === true);
      setManuals(visibleManuals);
    }
    setIsLoading(false);
    } catch (err) {
      setError("Error al cargar los manuales");
      setIsLoading(false);
      console.error("Error fetching manuals:", err);
    }
  };

useEffect(() => {
  fetchManuals("", dateFilters);
  fetchNews("", dateFilters);
}, []);

useEffect(() => {
  let objectUrl;
  let cancelled = false;

  setViewModalBlobUrl(null);
  setViewModalError(false);

  if (!viewModalUrl || !isViewModalOpen) return;

  axiosInstance.get(viewModalUrl, { responseType: 'blob' })
    .then(response => {
      if (cancelled) return;
      objectUrl = URL.createObjectURL(response.data);
      setViewModalBlobUrl(objectUrl);
    })
    .catch(err => {
      console.error('Error al cargar el documento:', err);
      if (!cancelled) setViewModalError(true);
    });

  return () => {
    cancelled = true;
    if (objectUrl) URL.revokeObjectURL(objectUrl);
  };
}, [viewModalUrl, isViewModalOpen]);

const handleSearch = (term) => {
  setSearchTerm(term);
  
  if (searchTimeout) {
    clearTimeout(searchTimeout);
  }
  
  const newTimeout = setTimeout(() => {
    fetchManuals(term, dateFilters);
    fetchNews(term, dateFilters);
  }, 500);
  
  setSearchTimeout(newTimeout);
};

const nextPdfSlide = () => {
  const totalItems = manuals.length + 1; // +1 por la tarjeta "Agregar"
  if (currentPdfIndex < totalItems - maxVisibleCards) {
    setCurrentPdfIndex(prev => Math.min(prev + maxVisibleCards, totalItems - maxVisibleCards));
  }
};

const prevPdfSlide = () => {
  if (currentPdfIndex > 0) {
    setCurrentPdfIndex(prev => Math.max(prev - maxVisibleCards, 0));
  }
};

const nextNewsSlide = () => {
  const totalItems = news.length + 1; // +1 por la tarjeta "Crear Noticia"
  if (currentNewsIndex < totalItems - maxVisibleNews) {
    setCurrentNewsIndex(prev => Math.min(prev + maxVisibleNews, totalItems - maxVisibleNews));
  }
};

const prevNewsSlide = () => {
  if (currentNewsIndex > 0) {
    setCurrentNewsIndex(prev => Math.max(prev - maxVisibleNews, 0));
  }
};

  const handleMouseDown = (e, carouselRef) => {
    setIsDragging(true);
    setStartX(e.pageX - carouselRef.current.offsetLeft);
    setScrollLeft(carouselRef.current.scrollLeft);
  };

  const handleMouseLeave = () => setIsDragging(false);
  const handleMouseUp = () => setIsDragging(false);

  const handleMouseMove = (e, carouselRef) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    carouselRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleTouchStart = (e, carouselRef) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - carouselRef.current.offsetLeft);
    setScrollLeft(carouselRef.current.scrollLeft);
  };


  const handleTouchMove = (e, carouselRef) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    carouselRef.current.scrollLeft = scrollLeft - walk;
  };

const handleViewDocument = async (manualId, pdfUrl) => {
  try {
    const response = await getManual(manualId);
    
    if (response.data && response.data.manual) {
      if (response.data.manual.visible === false) {
        setModalMessage("Este documento no está disponible para visualización.");
        setShowModalAlertWarning(true);
        setManuals(prev => prev.filter(m => m.id !== manualId));
        return;
      }
      
      setViewModalUrl(pdfUrl);
      setIsViewModalOpen(true);
    }
    
    } catch (error) { 
      console.error("Error verificando disponibilidad:", error);
    
    if (error.response && error.response.status === 400) {
      setModalMessage("Este documento ya no está disponible. Ha sido eliminado.");
    } else {
      setModalMessage("Error al verificar la disponibilidad del documento.");
    }
    
    setShowModalAlertWarning(true);
    setManuals(prev => prev.filter(m => m.id !== manualId));
  }
};

const clearFilters = () => {
  setSearchTerm("");
  setDateFilters({
    createDateFrom: "",
    createDateTo: ""
  });
  fetchManuals("", {});
  fetchNews("", {});
};

const handleDateRangeChange = ({ startDate, endDate }) => {
  const newDateFilters = {
    createDateFrom: startDate || "",
    createDateTo: endDate || ""
  };
  
  setDateFilters(newDateFilters);
  
  fetchManuals(searchTerm, newDateFilters);
  fetchNews(searchTerm, newDateFilters);
};


const handleDownload = async (manualId, title) => {
  try {
    console.log('Iniciando descarga del manual:', manualId);
    const response = await downloadManual(manualId);
    console.log('Respuesta exitosa:', response);    
    const blob = new Blob([response.data], { 
      type: response.headers['content-type'] || 'application/pdf' 
    });
    
    const contentDisposition = response.headers['content-disposition'];
    let fileName = title || "documento.pdf";
    
    if (contentDisposition) {
      const utf8FilenameRegex = /filename\*=UTF-8''(.+?)(?:;|$)/i;
      const standardFilenameRegex = /filename="?(.+?)"?(?:;|$)/i;
      
      let fileNameMatch = contentDisposition.match(utf8FilenameRegex);
      
      if (fileNameMatch && fileNameMatch.length > 1) {
        fileName = decodeURIComponent(fileNameMatch[1]);
      } else {
        fileNameMatch = contentDisposition.match(standardFilenameRegex);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }
    }
    
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
    return Promise.resolve(); 
    
  } catch (error) {
    console.error("Error descargando el manual:", error);
    console.error("Mensaje del error:", error.message);
    
    const errorMessage = error.message || "Error al descargar el documento";
    setModalMessage(errorMessage);
    setShowModalAlertWarning(true);
    
    return Promise.reject(error);
  }
};

  return (
    <div className="min-h-screen">
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 transition-all duration-300 pt-[67px]  bg-[#F7F8F9] w-full z-50 min-h-screen ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}`}>
        <div className="sm:pt-8 pt-6 pb-10 px-[5%] sm:px-[3%]">
            <div className="flex flex-col gap-3 ">   
                <div className="flex flex-col items-start justify-between gap-3 sm:items-center sm:flex-row">
                  <h1 className="text-blue font-itcbold  text-2xl md:text-[32px]">
                    Conócenos
                  </h1>
                  <div className="flex flex-col gap-3 sm:flex-row">
                    <FilterInput
                    title="Buscar"
                    value={searchTerm}
                    placeholder="Buscar por título"
                    onChange={(e) => handleSearch(e.target.value)}
                    />
                    <div className="flex items-center gap-3">
                      <DateFilterButton
                        onDateRangeChange={handleDateRangeChange}
                        activeFilters={dateFilters}
                        title="Filtrar por fecha de creación"
                      />
                      <ResetFilters
                      onClick={clearFilters}
                      font="font-itcbook"
                      borderColor="border-blue-light"
                      />
                    </div>                    
                  </div>
                </div>
                {(isLoading || manuals.length > 0) && (
                  <h2 className="font-itcmedium text-xl md:text-2xl text-[#6B7280]">
                    Lo que necesitas saber
                  </h2>
                )}

                {isLoading ? (
                <div className="relative">
                  <div className="grid grid-flow-col items-start pl-4 py-2 auto-cols-[230px] gap-6">
                    {[...Array(4)].map((_, index) => (
                      <PdfCardLoader key={index} />
                    ))}
                  </div>
                </div>
                ) : error ? (
                <div className="flex items-center justify-center h-64">
                  <p className="text-red-500">{error}</p>
                </div>
                ) :  manuals.length === 0 ? (
                <div className="flex items-center justify-center h-32 bg-white rounded-lg">
                  <p className="text-lg text-gray-500 font-itcmedium">No se encontraron manuales.</p>
                </div>
                ) : (
                <div className="relative">
                  {currentPdfIndex > 0 && (
                    <button onClick={prevPdfSlide} className="absolute z-10 transform rotate-180 -translate-y-1/2 cursor-pointer -left-1 sm:-left-2 md:-left-3 lg:-left-4 xl:-left-6 top-1/2">
                      <svg className="w-2 sm:w-3 md:w-4 lg:w-5 xl:w-6" viewBox="0 0 28 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M27 13.7679C28.3333 14.5377 28.3333 16.4622 27 17.232L3.75 30.6554C2.41667 31.4252 0.749998 30.463 0.749999 28.9234L0.75 2.0766C0.75 0.537005 2.41667 -0.425246 3.75 0.344555L27 13.7679Z" fill="#007696"/>
                      </svg>
                    </button>
                  )}

                  {currentPdfIndex < Math.max(0, (manuals.length) - maxVisibleCards) && (
                    <button 
                      onClick={nextPdfSlide} 
                      disabled={currentPdfIndex >= Math.max(0, (manuals.length) - maxVisibleCards)}
                      className={`absolute -right-3 sm:-right-4 md:-right-5 lg:-right-6 xl:-right-7 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer ${currentPdfIndex >= (manuals.length + 1) - maxVisibleCards ? 'opacity-30' : ''}`}
                    >
                      <svg className="w-2 sm:w-3 md:w-4 lg:w-5 xl:w-6" viewBox="0 0 28 31" fill="none">
                      <path d="M27 13.7679C28.3333 14.5377 28.3333 16.4622 27 17.232L3.75 30.6554C2.41667 31.4252 0.749998 30.463 0.749999 28.9234L0.75 2.0766C0.75 0.537005 2.41667 -0.425246 3.75 0.344555L27 13.7679Z" fill="#007696"/>
                      </svg>
                    </button>
                  )}

                  <div 
                    ref={pdfCarouselRef}
                    className="overflow-hidden"
                    onMouseDown={(e) => handleMouseDown(e, pdfCarouselRef)}
                    onMouseLeave={handleMouseLeave}
                    onMouseUp={handleMouseUp}
                    onMouseMove={(e) => handleMouseMove(e, pdfCarouselRef)}
                    onTouchStart={(e) => handleTouchStart(e, pdfCarouselRef)}
                    onTouchMove={(e) => handleTouchMove(e, pdfCarouselRef)}
                    onTouchEnd={handleMouseUp}
                    >
                      <div 
                        style={{ 
                          transform: `translateX(-${currentPdfIndex * (230 + 24)}px)`,
                          transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                        }}
                        className="grid grid-flow-col items-start pl-4  py-2 auto-cols-[230px] gap-6 transition-transform duration-300">
                        {/**lista */}

                        {manuals.map((manual) => (
                          <PdfCard
                            key={manual.id}
                            manualId={manual.id}
                            initialVisible={manual.visible}
                            pdfFile={manual.file}
                            title={manual.title}
                            adminMode={false}
                            onViewClick={() => handleViewDocument(manual.id, manual.file)}
                            onDownloadClick={() => handleDownload(manual.id, manual.title)}
                          />
                        ))}
                      </div>
                  </div>
                </div>
                )}

                {(isNewsLoading || news.length > 0) && (
                  <h2 className="font-itcmedium text-xl md:text-2xl text-[#6B7280]">Noticias</h2>
                )}
                {isNewsLoading ? (
                <div className="relative">
                  <div className="grid grid-flow-col auto-cols-[267px] pl-4 py-2 gap-8">
                    {[...Array(3)].map((_, index) => (
                      <NewsCardLoader key={index} />
                    ))}
                  </div>
                </div>
                ) : newsError ? (
                <div className="flex items-center justify-center h-64">
                  <p className="text-red-500">{newsError}</p>
                </div>
                ) : news.length === 0 ? (
                <div className="flex items-center justify-center h-32 bg-white rounded-lg">
                  <p className="text-lg text-gray-500 font-itcmedium">No se encontraron noticias.</p>
                </div>
                ) : (
                <div className="relative">
                  {currentNewsIndex > 0 && (
                    <button onClick={prevNewsSlide} className="absolute z-10 transform rotate-180 -translate-y-1/2 cursor-pointer -left-1 sm:-left-2 md:-left-3 lg:-left-4 xl:-left-6 top-1/2">
                      <svg className="w-2 sm:w-3 md:w-4 lg:w-5 xl:w-6" viewBox="0 0 28 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M27 13.7679C28.3333 14.5377 28.3333 16.4622 27 17.232L3.75 30.6554C2.41667 31.4252 0.749998 30.463 0.749999 28.9234L0.75 2.0766C0.75 0.537005 2.41667 -0.425246 3.75 0.344555L27 13.7679Z" fill="#007696"/>
                      </svg>
                    </button>
                  )}
                  {currentNewsIndex < Math.max(0, (news.length) - maxVisibleNews) && (
                    <button 
                      onClick={nextNewsSlide} 
                      disabled={currentNewsIndex >= Math.max(0, (news.length) - maxVisibleNews)}
                      className={`absolute -right-3 sm:-right-4 md:-right-5 lg:-right-6 xl:-right-7 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer
                        ${currentNewsIndex >= Math.max(0, (news.length + 1) - maxVisibleNews) ? 'opacity-30' : ''}`}
                    >
                      <svg className="w-2 sm:w-3 md:w-4 lg:w-5 xl:w-6" viewBox="0 0 28 31" fill="none">
                      <path d="M27 13.7679C28.3333 14.5377 28.3333 16.4622 27 17.232L3.75 30.6554C2.41667 31.4252 0.749998 30.463 0.749999 28.9234L0.75 2.0766C0.75 0.537005 2.41667 -0.425246 3.75 0.344555L27 13.7679Z" fill="#007696"/>
                      </svg>
                    </button>
                  )}

                  <div 
                    ref={newsCarouselRef}
                    className="flex-1 overflow-hidden"
                    onMouseDown={(e) => handleMouseDown(e, newsCarouselRef)}
                    onMouseLeave={handleMouseLeave}
                    onMouseUp={handleMouseUp}
                    onMouseMove={(e) => handleMouseMove(e, newsCarouselRef)}
                    onTouchStart={(e) => handleTouchStart(e, newsCarouselRef)}
                    onTouchMove={(e) => handleTouchMove(e, newsCarouselRef)}
                    onTouchEnd={handleMouseUp}
                    >
                      <div 
                        style={{
                          transform: `translateX(-${currentNewsIndex * (267 + 32)}px)`,
                          transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                        }}
                        className="grid grid-flow-col auto-cols-[267px] pl-4  py-2 gap-8 transition-transform duration-300">

                        {news.map((newsItem) => (
                        <NewsCard
                          key={newsItem.id}
                          id={newsItem.id}
                          title={newsItem.title}
                          description={newsItem.advance} 
                          image={newsItem.image_list} 
                          date={new Date(newsItem.created_At).toLocaleDateString('es-ES', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric'
                          })} 
                          initialVisible={newsItem.visible}
                        />
                        ))}
                      </div>
                  </div>
                </div>
                )}
            </div>
        </div>
        {/**ver documento */}
        {isViewModalOpen && viewModalUrl && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="flex flex-col w-[80vw] h-[80vh] bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="flex justify-end p-4 bg-gray-100">
                <button
                  onClick={() => {
                    setIsViewModalOpen(false);
                    setViewModalUrl(null);
                  }}
                  className="text-3xl leading-none text-gray hover:text-gray-700"
                >
                  &times;
                </button>
              </div>
              <div className="flex items-center justify-center flex-1">
                {viewModalError ? (
                  <p className="text-gray-500 font-itcbook">El archivo no existe.</p>
                ) : viewModalBlobUrl ? (
                  <iframe
                    src={viewModalBlobUrl}
                    title="Ver Manual"
                    className="w-full h-full"
                  />
                ) : (
                  <svg className="w-10 h-10 text-blue-600 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                  </svg>
                )}
              </div>
            </div>
          </div>
        )}


        {showModalAlertWarning && (
          <ModalAlertWarning
            showModalAlertWarning={showModalAlertWarning} 
            closeModal={() => {
              console.log('Cerrando modal de alerta');
              setShowModalAlertWarning(false);
            }}
            error={modalMessage}  
            showAcceptButton={true}
          />
        )}

      </div>

    </div>
    
  );
}